var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{attrs:{"href":"#"}},[_c('em',[_vm._v(_vm._s(_vm.currentUser.nickname))])]),_c('b-avatar',{attrs:{"src":_vm.currentUser.avatarUrl}}),_c('b-button',{staticClass:"mx-3",attrs:{"variant":"outline-light"},on:{"click":_vm.signOut}},[_c('strong',[_vm._v("Sign Out")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }